<script setup>
import PageHero from '@/views/front-pages/PageHero.vue'
import PublicPageShell from '@/views/front-pages/PublicPageShell.vue'
import { useConfigStore } from '@core/stores/config'

definePage({ meta: { layout: 'blank', public: true } })

const store = useConfigStore()

store.skin = 'default'

const sections = [
  {
    title: '1. Data yang Kami Kumpulkan',
    body: [
      'Data pendaftaran: nama bisnis, nama pemilik, email, dan nomor HP/WhatsApp saat Anda mendaftar akun.',
      'Data operasional bisnis: produk, transaksi, stok bahan baku, dan data pelanggan yang Anda input sendiri ke dalam sistem untuk menjalankan usaha Anda.',
      'Data teknis dasar: alamat IP dan jenis perangkat/browser, untuk keamanan dan pemecahan masalah teknis.',
    ],
  },
  {
    title: '2. Tujuan Penggunaan Data',
    body: [
      'Menyediakan dan menjalankan layanan PintuKasir sesuai paket yang Anda pilih.',
      'Memproses pembayaran langganan dan mengirim invoice/konfirmasi terkait.',
      'Mengirim struk transaksi ke pelanggan Anda (WhatsApp/Email) sesuai fitur yang Anda aktifkan.',
      'Merespons pertanyaan atau tiket bantuan yang Anda ajukan ke tim support.',
      'Mengirim update fitur atau informasi penting lain terkait layanan (bisa berhenti berlangganan kapan saja untuk newsletter).',
    ],
  },
  {
    title: '3. Penyimpanan & Keamanan Data',
    body: [
      'Setiap tenant (akun bisnis) terisolasi penuh di level database -- tenant lain tidak bisa mengakses data Anda.',
      'Semua koneksi ke aplikasi dienkripsi via HTTPS/SSL, dan backup dilakukan otomatis setiap hari.',
      'Data disimpan selama akun Anda aktif berlangganan, dan selama 90 hari setelah langganan berakhir untuk keperluan pemulihan jika Anda ingin melanjutkan kembali. Setelah itu, data dihapus permanen kecuali Anda meminta lebih awal.',
    ],
  },
  {
    title: '4. Hak Anda sebagai Pemilik Data',
    body: [
      'Hak Akses: meminta salinan data yang kami simpan tentang bisnis/akun Anda.',
      'Hak Koreksi: memperbaiki data yang tidak akurat, langsung dari dashboard atau lewat tim support.',
      'Hak Hapus: meminta penghapusan data Anda setelah langganan berakhir.',
      'Hak Menarik Persetujuan: berhenti berlangganan newsletter/update kapan saja lewat link unsubscribe atau permintaan ke tim support.',
    ],
  },
  {
    title: '5. Berbagi Data ke Pihak Ketiga',
    body: [
      'Kami hanya membagikan data seperlunya ke penyedia layanan yang mendukung operasional PintuKasir: payment gateway (Xendit/Midtrans) untuk memproses pembayaran, dan penyedia email/WhatsApp untuk mengirim struk atau notifikasi. Kami tidak menjual data Anda ke pihak mana pun.',
    ],
  },
  {
    title: '6. Kontak Terkait Privasi',
    body: [
      'Ada pertanyaan soal data Anda? Hubungi kami di support@pintukasir.com atau lewat halaman Kontak.',
    ],
  },
]
</script>

<template>
  <PublicPageShell>
    <PageHero
      eyebrow="Legal"
      eyebrow-icon="ri-shield-check-line"
      title="Kebijakan Privasi"
      subtitle="Bagaimana PintuKasir mengumpulkan, menggunakan, dan melindungi data Anda."
    />

    <section class="legal-section pb-16">
      <VContainer>
        <VRow justify="center">
          <VCol
            cols="12"
            md="9"
            lg="8"
          >
            <VCard rounded="xl" variant="outlined">
              <VCardText class="pa-6 pa-md-8">
                <p class="text-caption text-medium-emphasis mb-6">
                  Terakhir diperbarui: Agustus 2026
                </p>

                <div
                  v-for="section in sections"
                  :key="section.title"
                  class="mb-6"
                >
                  <h2 class="text-h6 font-weight-bold mb-3">
                    {{ section.title }}
                  </h2>
                  <ul class="legal-list">
                    <li
                      v-for="(line, i) in section.body"
                      :key="i"
                      class="text-body-2 text-medium-emphasis mb-2"
                      style="line-height: 1.7"
                    >
                      {{ line }}
                    </li>
                  </ul>
                </div>
              </VCardText>
            </VCard>
          </VCol>
        </VRow>
      </VContainer>
    </section>
  </PublicPageShell>
</template>

<style lang="scss" scoped>
.legal-list {
  padding-inline-start: 1.25rem;
  margin: 0;
}
</style>
